import React from "react";
import Settings from "../Settings";

export default function Logout(props) {
    return (
        <Settings {...props} logout={true}/>
    )
}
